import { IFreeTextMediaListVM } from "../../models/response/IMediaResponse";

export const initialState: IFreeTextMediaListVM = {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
   FreeText: [],
}